import { REPOSITION_ANCHORED_ELEMENT } from "../../actions";
import ItemTypes from "../../constants/ItemTypes";

export default function (state = {}, action) {
  switch (action.type) {
    case REPOSITION_ANCHORED_ELEMENT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };

          if (layer.layer_id === action.payload.layerId) {
            if (action.payload.itemType === ItemTypes.TEXT) {
              layer.text_elements = layer.text_elements.map(
                (element, index) => {
                  if (index === action.payload.index) {
                    const oldLeftPosition = element.left_position,
                      oldTopPosition = element.top_position,
                      oldHeight = action.payload.oldHeight,
                      newHeight = action.payload.newHeight,
                      oldWidth = action.payload.oldWidth,
                      newWidth = action.payload.newWidth,
                      diffWidth = newWidth - oldWidth,
                      diffHeight = newHeight - oldHeight;

                    let newLeftPosition = oldLeftPosition;
                    let newTopPosition = oldTopPosition;

                    if (element.anchor_point === "center") {
                      newLeftPosition = oldLeftPosition - diffWidth / 2;
                      newTopPosition = oldTopPosition - diffHeight / 2;
                    } else if (element.anchor_point === "right") {
                      newLeftPosition = oldLeftPosition - diffWidth;
                      if (
                        (element.rotation >= 180 && element.rotation < 270) ||
                        (element.rotation >= 0 && element.rotation < 90)
                      ) {
                        newTopPosition = oldTopPosition - diffHeight;
                      }
                    } else if (element.anchor_point === "left") {
                      if (
                        (element.rotation >= 270 && element.rotation < 360) ||
                        (element.rotation >= 90 && element.rotation < 180)
                      ) {
                        newTopPosition = oldTopPosition - diffHeight;
                      }
                    }

                    return {
                      ...element,
                      left_position: newLeftPosition,
                      top_position: newTopPosition,
                    };
                  } else {
                    return {
                      ...element,
                    };
                  }
                },
              );
            } else {
              layer.image_elements = layer.image_elements.map(
                (element, index) => {
                  if (index === action.payload.index) {
                    const oldLeftPosition = element.left_position,
                      oldWidth =
                        action.payload.oldWidth / (state.preview_scale * 72),
                      newWidth =
                        action.payload.newWidth / (state.preview_scale * 72),
                      difference = newWidth - oldWidth;

                    let newLeftPosition = oldLeftPosition;

                    if (element.anchor_point === "center") {
                      newLeftPosition = oldLeftPosition - difference / 2;
                    } else if (element.anchor_point === "right") {
                      newLeftPosition = oldLeftPosition - difference;
                    }

                    return {
                      ...element,
                      left_position: newLeftPosition,
                    };
                  } else {
                    return {
                      ...element,
                    };
                  }
                },
              );
            }
          }
          return layer;
        }),
      };

    default:
      return state;
  }
}
